
import { Button } from "@/components/ui/button";
import { ArrowRight, Sparkles, LogIn } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

interface HeroSectionProps {
  backgroundImages: string[];
}

export const HeroSection = ({ backgroundImages }: HeroSectionProps) => {
  const { user, isLoading, navigateToDashboard } = useAuth();

  return (
    <section className="w-full h-full flex flex-col items-center justify-center">
      
      <div className="container flex flex-col items-center px-4 mx-auto">
        <div className="animate-fade-in opacity-0 w-full text-center px-2" style={{animationDelay: "0ms", animationFillMode: "forwards"}}>
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-heading font-extrabold text-gradient bg-gradient-neon bg-200% animate-text-shimmer tracking-tight">
            NocheLoco
          </h1>
        </div>
        
        <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-center my-3 animate-fade-in opacity-0" style={{animationDelay: "100ms", animationFillMode: "forwards"}}>
          Your <span className="text-primary font-extrabold">All-Access</span> Passport to Nightlife
        </h1>
        
        <p className="text-base md:text-lg font-body text-center text-muted-foreground mb-4 max-w-3xl animate-fade-in opacity-0 leading-relaxed" style={{animationDelay: "300ms", animationFillMode: "forwards"}}>
          From discovery to payment, one platform connects patrons, artists, promoters, and venues in Australia's smartest nightlife ecosystem.
        </p>
      </div>
      
      <div className="fixed bottom-0 left-0 right-0 p-4 glass-card md:hidden z-50 m-4 rounded-2xl">
        <Button 
          onClick={navigateToDashboard}
          variant="premium"
          size="lg"
          className="w-full"
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <div className="mr-2 h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent"></div>
              Loading...
            </>
          ) : (
            <>
              {user ? "Go to Dashboard" : "Start Your Night"}
              <ArrowRight className="ml-2 h-5 w-5" />
            </>
          )}
        </Button>
      </div>
    </section>
  );
};
